export enum MembershipPlanView {
  PRO = 'pro',
  FREE = 'free'
}
